<template>
    <transition name="slide-fade" >
        <div  id="academicsHolder" >
            <div class="uk-child-width-1-1" uk-grid>
                <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            There is always another way. We understand various circumstances and we make provisions to facilitate you
                        </p>
                    </div>
                </div>


                <div class="uk-padding  uk-background-muted uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading">Provisional Admission</h1>
                    <div class="uk-container uk-container-small">
                        <div class=" " uk-grid>
                            <div class="uk-container uk-container-small">
                                <h3 class="uk-heading-bullet specHeading">
                                    Awaiting External Examination Results
                                </h3>
                                <p class="uk-text-muted uk-text-small">

                                    Consideration is given to high school seniors whose external examination results are not
                                    available by the time of registration. However, all criteria of the acceptance letter issued must
                                    be met within 1 year of application or students must withdraw.

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-padding  uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">Pre-University</h3>
                        <p class="uk-text-small">
                            Applicants with at least three external passes (GCE/CSEC) at grade C or Level III, respectively and
                            a satisfactory transcript from a recognised high school qualify for entry into Pre-University.
                        </p>
                        <p class="uk-text-small">
                            Through the Pre-University Department, Northern Caribbean University serves high school
                            graduates who are not immediately qualified for matriculation into specific academic
                            programmes of the University. Students are prepared to sit external examinations while being
                            allowed to take a limited number of university credits. The Pre-University programme allows the
                            student to obtain outstanding subjects within one year, at which point the student advances or
                            withdraws. Pre-University students are not able to declare a major until they have complete
                            matriculation requirements.
                        </p>
                        <p class="uk-text-small">
                            A Pre-University student is understood to be ANY student registered for one or more preuniversity
                            subjects. Students are required to register for the Pre-University subject in the
                            Pre-university department and not privately. The specifications of this registration are set out
                            below:
                        </p>
                        <div class="uk-text-small" uk-grid>
                            <div class="uk-width-1-5"></div>
                            <div class="uk-width-3-5">
                                <table class="uk-table uk-table-responsive uk-table-divider">
                                    <thead>
                                    <tr>
                                        <th>Pre-University</th>
                                        <th>University Credits</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>3 subjects</td>
                                        <td>No credits</td>

                                    </tr>
                                    <tr>
                                        <td>2 subjects</td>
                                        <td>6 credits</td>

                                    </tr>
                                    <tr>
                                        <td>1 subject</td>
                                        <td>9 credits</td>

                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="uk-width-1-5"></div>
                        </div>
                    </div>
                </div>

                <div class="uk-padding uk-background-muted uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">Mature Age Entrance</h3>
                        <p class="uk-text-small">
                            Applicants over the age of 25 may be granted admission based on their work experience,
                            maturity and performance on the University’s Mature Age Entrance Examination (MAE).
                            Interviews are done and recommendations from employers are evaluated for these applicants.
                            Students will be allowed to register for a <span class="uk-text-bold">maximum</span> of 10 credits per semester for the first
                            year. Students accepted on this basis will be placed on one year’s probation. They must
                            complete the first 20 credits, while maintaining an overall GPA of 2.50.
                        </p>
                        <p class="uk-text-small">
                            The Mature Age Examination consists of three (3) sections: English, Mathematics and a
                            General Paper that includes Science and Current Events. This exam is administered two times
                            a year: <span class="uk-text-bold">Fall and Spring, on the last Thursday of May and October</span>. Candidates may choose the
                            one appropriate to the desired time of entry. A minimum pass mark of 60% on all three
                            sections is required for this basis of entry. <span class="uk-text-bold">Applicants are allowed to sit the exam once per
              year.</span>
                        </p>
                    </div>
                </div>

                <div class="uk-padding  uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">Technical and Vocational Graduates</h3>
                        <p class="uk-text-small">
                            Applicants who are graduates and of Technical or Vocational programmes must have
                            successful completion of Grade I or II Certificate from Secondary level Technical/Vocational
                            Schools
                        </p>

                    </div>
                </div>

                <div class="uk-padding uk-background-muted uk-margin-remove-top">
                    <div class="uk-container uk-container-small">
                        <h3 class="uk-heading-bullet specHeading">Special Students</h3>
                        <ul class="uk-list uk-list-divider uk-text-small">
                            <li>
                                <span class="uk-text-bold"> Non-degree.</span> This refers to individuals who do not qualify for regular University
                                admission, but who may wish to benefit from university classes. They may be admitted
                                into certain courses, do all class work, sit for all tests and be issued grades. A nondegree
                                student enrolment is limited to two semesters and a maximum of 10 credits per
                                semester.
                            </li>
                            <li>
                                <span class="uk-text-bold">Unclassified.</span> This term applies to any student who meets admissions standards, but who
                                has not decided upon a major. It may also refer to students whose classification cannot
                                be determined at the time of admission. All examinations are taken and grades are
                                issued. Credits earned may later apply toward a degree.
                            </li>
                            <li>
                                <span class="uk-text-bold">Transient Students.</span> This refers to students who are registered at other approved tertiary
                                institutions, but choose to take some classes at Northern Caribbean University with the
                                intention that credits thus earned will be transferred to the students’ original institution.
                                If a college or university gives prior approval to the arrangement, no transcript is
                                required. A letter is required from the Registrar or Vice-president for Academic
                                Administration, certifying that the students are in good and regular standing at their
                                home institution.
                            </li>
                        </ul>

                    </div>
                </div>

                <div class="uk-padding uk-background-muted">
                    <div class="uk-container uk-container-small uk-padding-small">
                        <div uk-grid>

                            <div class="uk-width-1-1">
                                <h3 class="uk-heading-bullet uk-text-muted">Incomplete Applications</h3>
                                <p class="uk-text-small uk-text-muted">
                                    Applicants are reminded that if they were given provisional acceptance and have not yet fulfilled the requirements for acceptance into their programmes,
                                    which include meeting the standard for matriculation, be interviewed by their departments and submission of all outstanding documents, they will not be
                                    given a formal acceptance letter at the New Students’ Meeting.

                                    <br><br>
                                    If you have any questions concerning your admissions process, please feel free to call us at the office at:
                                    <br><br>
                                    Phone: 1-876-963-7255 | 1-876-963-7257 | Fax: 1-876-962-0075
                                    <br><br>
                                    For more information contact recruitment@ncu.edu.jm
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </transition>
</template>

<script>
    export default {
        name: "ProvisionalAcceptance",
        mounted(){
            //window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>

</style>
